module.exports = __webpack_public_path__ + "media/images/btn_set-56f590ee39e3714eae3630ac03a9f619.gif";